import { PATH_THANKYOU } from "../../constants/Paths";
import { proceedAddToExistingOrderToServer } from "../../logic/server/OrderFunction";
import { buildOrderPayloadV2 } from "../../logic/server/PayloadBuilder";

/**
 * Submit function specifically for new-to-existing order workflow
 * This function calls the /api/order/add-to-existing endpoint
 * instead of the regular order amendment endpoint
 */
export const submitAddToExistingOrder = async (
  utils,
  user,
  order,
  newItemsToAdd, // Only the new items user wants to add
  existingOrder,
  selectedStore = null
) => {
  const { webApp, sessionToken, navigate } = utils;
  
  try {
    const {
      userId,
      userName, 
      agentId,
      routeDetails,
      customerName,
      customerContact,
      customerAddress,
      timeSlot,
      customerComments,
    } = user;

    const {
      paymentCost,
      charges,
    } = order;

    console.log('=== SUBMIT NEW-TO-EXISTING ORDER ===');
    console.log('New Items to Add:', newItemsToAdd);
    console.log('Existing Order:', existingOrder);
    console.log('Payment Cost:', paymentCost);

    // Build order payload for new-to-existing workflow
    const orderPayload = buildOrderPayloadV2(
      {
        userId: userId,
        userName: userName
      },
      {
        orderName: customerName,
        orderPhone: customerContact,
        orderAddress: customerAddress,
        comments: customerComments || 'New-to-existing order workflow'
      },
      {
        address: customerAddress,
        district: null,
        state: null
      },
      {
        enabledBaseManualPricing: false,
        enabledAgentPolicyManualPricing: false
      },
      newItemsToAdd, // Send only NEW cart items, not merged
      timeSlot,
      {
        charges: charges || [],
        finalTotalCost: paymentCost,
        systemTotalCost: paymentCost
      },
      routeDetails,
      agentId
    );

    // Add existing order information to the payload
    orderPayload.Body.ExistingOrder = existingOrder;
    
    console.log('=== SENDING TO NEW-TO-EXISTING BACKEND ===');
    console.log('Order Payload:', JSON.stringify(orderPayload, null, 2));
    
    // Call the add-to-existing API instead of edit API
    const result = await proceedAddToExistingOrderToServer(
      sessionToken, 
      orderPayload, 
      selectedStore
    );

    // Only navigate to success page if order was actually processed successfully
    if (result && result.success && result.order) {
      console.log('=== NEW-TO-EXISTING ORDER SUCCESS ===');
      console.log('Response:', result);
      
      navigate(PATH_THANKYOU, {
        replace: true,
        state: {
          orderData: result.data,
          isNewToExisting: true
        }
      });
    } else {
      // Handle failed order addition
      webApp.MainButton.hideProgress(true);
      webApp.BackButton.show();
      webApp.MainButton.enable();
      
      throw new Error(result?.error || "Failed to add items to existing order");
    }
  } catch (error) {
    console.error("submitAddToExistingOrder failed:", error);
    webApp.MainButton.hideProgress(true);
    webApp.BackButton.show();
    webApp.MainButton.enable();
    
    // Show user-friendly error message
    alert(`Failed to add items to existing order:\n\n${error.message}`);
    
    throw error;
  }
};